// extracted by mini-css-extract-plugin
export var closeButton = "_z-5";
export var container = "_z-0";
export var contentContainer = "_z-1";
export var desktop = "_z-2";
export var fullModalImage = "_z-6";
export var mobile = "_z-3";
export var withImage = "_z-4";